export enum MedicalHistoryEnum {
  ALLERGY_INTOLERANCE = 'allergyIntolerance',
  CONDITION = 'condition',
  FAMILY_MEMBER_HISTORY = 'familyMemberHistory',
  MEDICATION_STATEMENT = 'medicationStatement',
  PROCEDURE = 'procedure',
  PERSONAL_AND_SOCIAL = 'personal_and_social',
}
